import React, { Component } from "react";

export default class RoomRugFilterSizes extends Component {
  render() {
    return (
      <ul className="rug-metrage">
        <li
          className={this.props.selectedSizes.indexOf(6) >= 0 ? "active" : ""}
          onClick={() => this.props.selectHandler(6, "sizes")}
        >
          {this.props.texts["rug_size_6"]}
        </li>
        <li
          className={this.props.selectedSizes.indexOf(9) >= 0 ? "active" : ""}
          onClick={() => this.props.selectHandler(9, "sizes")}
        >
          {this.props.texts["rug_size_9"]}
        </li>
        <li
          className={this.props.selectedSizes.indexOf(12) >= 0 ? "active" : ""}
          onClick={() => this.props.selectHandler(12, "sizes")}
        >
          {this.props.texts["rug_size_12"]}
        </li>
      </ul>
    );
  }
}
